import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "option-card"
};
import { onMounted, reactive } from 'vue';
import LlDatePicker from '../../../../components/LlDatePicker.vue';
export default {
  __name: 'DateRangeSetup',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    companyBillingState: {
      type: Object,
      required: true
    },
    modalValue: {
      type: String,
      required: true
    },
    expenseWizardState: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const dateRangeSetupState = reactive({
      readonly: false,
      date: new Date()
    });
    onMounted(async () => {
      dateRangeSetupState.date = props.modalValue;
    });
    const updateDate = date => {
      dateRangeSetupState.date = date;
      props.expenseWizardState.data.syncDate = date;
    };
    return (_ctx, _cache) => {
      const _component_v_container = _resolveComponent("v-container");
      return _openBlock(), _createBlock(_component_v_container, {
        class: "w-full h-full pa-2"
      }, {
        default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "question-section mb-2"
        }, " LeanLaw will bring over all existing expenses from the account in QuickBooks. Pick a date to prevent syncing older items: ", -1)), _createElementVNode("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "option-header mb-2"
        }, [_createElementVNode("label", null, [_createElementVNode("strong", null, "Only from this date")])], -1)), _createVNode(LlDatePicker, {
          modelValue: dateRangeSetupState.date,
          "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => dateRangeSetupState.date = $event), _cache[1] || (_cache[1] = $event => updateDate($event))],
          disabled: dateRangeSetupState.readonly,
          style: {
            "max-width": "380px"
          }
        }, null, 8, ["modelValue", "disabled"])])]),
        _: 1
      });
    };
  }
};